// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jnsm","rootNoMargin":"styles_rootNoMargin__2TxZi"};